import { render, staticRenderFns } from "./applications-publisher.vue?vue&type=template&id=253e37d7&scoped=true&"
import script from "./applications-publisher.vue?vue&type=script&lang=js&"
export * from "./applications-publisher.vue?vue&type=script&lang=js&"
import style0 from "./applications-publisher.vue?vue&type=style&index=0&id=253e37d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e37d7",
  null
  
)

export default component.exports